import React from "react";
import BottomSheet from "../../BottomSheet";
import Button from "../../Button";

interface CGMHardSyncBottomSheetProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const CGMHardSyncBottomSheet: React.FC<CGMHardSyncBottomSheetProps> = ({
  show,
  onClose,
  onSubmit,
}) => {
  return (
    <BottomSheet
      show={show}
      title="Sync CGM Data (Hard Sync)?"
      handleClose={onClose}
      zIndex={60}
    >
      <div className="p-4">
        <p className="text-sm text-gray-500">
          This will pull all glucose readings from your device and sync them to
          the server. This may take a few minutes to complete.
        </p>

        <div className="flex gap-3 mt-4">
          <Button onClick={onClose} variant="outlined" rounded="full" fullWidth>
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            variant="contained"
            rounded="full"
            fullWidth
          >
            Sync Now
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMHardSyncBottomSheet;
